import React, { Component, useState } from "react";
import { Route } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { scAxiosAdmin } from "../..";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import RadioGroup from "../RadioGroup";
import "./emergency.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import thanas from "../../assets/data/thana.json";
import { error } from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import GalleryForEmergency from "./GalleryForEmergency";
import AmbulanceService from "./AmbulanceService";
import AmbulanceGallery from "./AmbulanceGallery";
const ServiceFormView = () => {
  const [formData, setFormData] = useState({
    type: "emergency",
    first_name: "",
    phone_number: "",
    emergencynumber: "",
    date_of_birth: "",
    blood_group: "",
    gender: "",
    condition: "",
    address: "",
    thana: "",
    need_ambulance: "",
    pickup_address: "",
    user_file: null,
    email: localStorage.getItem("USER_EMAIL"),
  });
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  const handleClick = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const req = scAxiosAdmin.post(
      "/emergenecies_enquiry",
      { ...formData, additional: { condition: formData.condition } },
      {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }
    );
    req
      .then((response) => {
        if (response.status === 201) {
          toast.success("Your request is received, you will be notified soon!");
        } else {
          toast.error("Ops something went wrong!");
        }
      })
      .catch((error) => {
        toast.error(error.response.statusText);
        // console.log(error)
      });
  };

  const options = [
    { label: "Home", value: "Home", index: 0 },
    { label: "Hospital", value: "Hospital", index: 1 },
    // { label: "Ambulance Service", value: "Ambulance" },
  ];
  const bloodGroup = [
    {
      type: "Positive",
      options: [
        { label: "A+", value: "A+" },
        { label: "AB+", value: "AB+" },
        { label: "B+", value: "B+" },
        { label: "O+", value: "O+" },
      ],
    },
    {
      type: "Negative",
      options: [
        { label: "A-", value: "A-" },
        { label: "AB-", value: "AB-" },
        { label: "B-", value: "B-" },
        { label: "O-", value: "O-" },
      ],
    },
  ];

  const rhFactor = [
    { label: "Positive (+)", value: "+" },
    { label: "Negative (-)", value: "-" },
  ];
  const gender = [
    { label: "Male ", value: "Male", index: 0 },
    { label: "Female ", value: "Female", index: 1 },
    // { label: "Others (O)", value: "O" },
  ];
  const ambulance = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];
  // Accessing positive blood group options
  const positiveBloodTypes = bloodGroup.find(
    (group) => group.type === "Positive"
  ).options;

  // Accessing negative blood group options
  const negativeBloodTypes = bloodGroup.find(
    (group) => group.type === "Negative"
  ).options;

  return (
    <div>
      <SEO
        title="Emergency | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Emergency"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin">
        <section className="banner-hero">
          <img
            src="/static/media/banner-profile.f160a4c1.jpg"
            alt="banner-profile"
            className="w-100"
          />
        </section>
        <section className="prof-dr">
          <div className="container pb-5">
            <div
              className="d-flex container justify-content-start align-items-center pt-4"
              style={{ paddingBottom: "2.3rem" }}
            >
              <div class="bg-white p-0" style={{}}>
                <a href="tel:10666">
                  <h1
                    className="text-center category-list-link open-cat-list"
                    style={{ backgroundColor: "red", borderRadius: "10px" }}
                  >
                    Call Emergency Line <br />
                    <h1>
                      {" "}
                      <i className="fa fa-phone mt-2 "></i>
                      10666
                    </h1>
                  </h1>
                </a>
              </div>
            </div>
            <div className="box-of-about ">
              <div class="container">
                <div class="row gy-4">
                  <div class="col-md-12">
                    <h2 className=" text-left mb-5">
                      Emergency Transfer Request Form
                    </h2>
                    <div className="text-profile ">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="form-group col-md-4">
                            <label htmlFor="firstName">Patient's Name:</label>
                            <input
                              type="text"
                              className="form-control"
                              id="firstName"
                              name="first_name"
                              value={formData.first_name}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          <div className="form-group col-md-4">
                            <label htmlFor="phoneNumber">
                              Emergency Contact Number:
                            </label>
                            <input
                              type="tel"
                              className="form-control"
                              id="phone_number"
                              name="phone_number"
                              value={formData.phone_number}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          <div className="form-group col-md-4">
                            <label htmlFor="dataOfBirth">Date of Birth:</label>
                            <br />
                            <input
                              type="date"
                              id="date_of_birth"
                              onChange={handleChange}
                              name="date_of_birth"
                              style={{ width: "100%", padding: 4 }}
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="gender">Gender:</label>
                          <div className="radio-button-group">
                            {gender.map((option, index) => (
                              <label
                                style={{
                                  backgroundColor:
                                    option.value === formData.gender
                                      ? "#0c807d"
                                      : "transparent",
                                  color:
                                    option.value === formData.gender
                                      ? "#ffffff"
                                      : "black",
                                  borderRadius: "5px",
                                  border: "1px solid #80808042",
                                }}
                                key={option.value}
                                className={`radio-button ${
                                  formData.gender === option.value
                                    ? "active"
                                    : ""
                                } me-3 py-2 pe-3`}
                              >
                                <input
                                  type="radio"
                                  name="gender"
                                  value={option.value}
                                  checked={formData.gender === option.value}
                                  onChange={() =>
                                    handleClick("gender", option.value)
                                  }
                                  style={{ visibility: "hidden" }}
                                />
                                {option.label}
                              </label>
                            ))}
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="condition">Condition:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="condition"
                            name="condition"
                            value={formData.condition}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="form-group d-flex flex-column">
                          <label htmlFor="needAmbulance">
                            Do you need an ambulance?
                          </label>
                          <div className="">
                            {ambulance.map((option, index) => (
                              <label
                                style={{
                                  backgroundColor:
                                    option.value === formData.need_ambulance
                                      ? "#0c807d"
                                      : "transparent",
                                  color:
                                    option.value === formData.need_ambulance
                                      ? "#ffffff"
                                      : "black",
                                  borderRadius: "5px",
                                  border: "1px solid #80808042",
                                }}
                                key={option.value}
                                className={`radio-button ${
                                  formData.need_ambulance === option.value
                                    ? "active"
                                    : ""
                                } me-3 py-2 pe-3`}
                              >
                                <input
                                  type="radio"
                                  name="gender"
                                  value={option.value}
                                  checked={
                                    formData.need_ambulance === option.value
                                  }
                                  onChange={() =>
                                    handleClick("need_ambulance", option.value)
                                  }
                                  style={{ visibility: "hidden" }}
                                />
                                {option.label}
                              </label>
                            ))}
                          </div>
                        </div>
                        {formData.need_ambulance == "Yes" && (
                          <div className="form-group">
                            <label htmlFor="pickupLocationAddress">
                              Pick up location Address:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="pickup_address"
                              name="pickup_address"
                              value={formData.pickup_address}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        )}

                        <div className="form-group ">
                          <label htmlFor="document">
                            Case Summary Upload:{" "}
                          </label>
                          <input
                            type="file"
                            className="form-control-file px-1"
                            id="user_file"
                            name="user_file"
                            onChange={handleChange}
                          />
                        </div>

                        <button
                          className="buts"
                          style={{ color: "#fff" }}
                          type="submit"
                          disabled={formData.isButtonDisabled}

                          // className="text-center category-list-link open-cat-list border-0 rounded"
                        >
                          Submit
                        </button>
                      </form>
                    </div>

                    <hr className="w-50 mx-auto my-5 " />
                    <GalleryForEmergency></GalleryForEmergency>

                    <AmbulanceService></AmbulanceService>

                    <AmbulanceGallery></AmbulanceGallery>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Route component={Footer} />
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default ServiceFormView;



// WEBPACK FOOTER //
// ./src/component/frontend/emergency.js